"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompRefAPISym = void 0;
exports.CompRefAPISym = Symbol.for('GetCompRefById');
//# sourceMappingURL=interfaces.js.map